/**
 * Constantes relacionadas ao Artemis Ads SDK
 */

export const ARTEMIS_ZONES = {
  /** Zona de Apps (Zone 2) */
  APPS: 'c0e16d43-4039-446e-a708-0bec66259111',
} as const;

export const ARTEMIS_CONFIG = {
  /** Limite padrão de campanhas por requisição */
  DEFAULT_LIMIT: 100,
  /** Número máximo de tentativas em caso de erro */
  MAX_RETRIES: 3,
  /** Timeout para requisições (em ms) */
  REQUEST_TIMEOUT: 30000,
} as const;
